import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { getCleanViewedAdsMap } from './useViewedAds.helpers';
import { usePageType } from '@/hooks/usePageType';
import { ROUTES } from '@/constants/routes';
import { PageType } from '@/hooks/usePageType/usePageType.types';

export function useViewedAds() {
  const { pathname, asPath } = useRouter();
  const pageType = usePageType();

  const canShowViewedState =
    pathname === ROUTES.home ||
    [PageType.Search, PageType.Ad, PageType.Shop].includes(pageType);

  const viewedIds = useMemo(() => {
    if (!canShowViewedState) return new Set<string>();

    try {
      if (typeof window === 'undefined') return new Set<string>();
      return new Set(Object.keys(getCleanViewedAdsMap()));
    } catch {
      return new Set<string>();
    }
  }, [canShowViewedState, asPath]);

  return { canShowViewedState, viewedIds };
}
